import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { authFetch } from '../../utils/api';
import { NavIconRunway, NavIconGauge, NavIconRoute, NavIconTarget } from './NavIcons';

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, token } = useAuth();
  const [cfiPendingCount, setCfiPendingCount] = useState(0);

  useEffect(() => {
    if (user && token) {
      authFetch('/api/cfi/pending-count', token)
        .then(d => setCfiPendingCount(d.count || 0))
        .catch(() => {});
    }
  }, [user, token]);

  const path = location.pathname;

  const allTabs = {
    flights: { id: 'flights', label: 'Flights',  Icon: NavIconRunway, active: path === '/flights' || path.startsWith('/flight/'), path: '/flights', auth: false },
    plan:    { id: 'plan',    label: 'Brief', Icon: NavIconRoute,  active: path === '/plan',      path: '/plan',      auth: true },
    dash:    { id: 'dash',    label: 'Dash',  Icon: NavIconGauge,  active: path === '/dashboard', path: '/dashboard', auth: true },
    train:   { id: 'train',   label: 'Train', Icon: NavIconTarget, active: path === '/train',     path: '/train',     auth: true },
  };

  const userTabOrder = user?.app_settings?.tab_order || ['flights', 'plan', 'dash', 'train'];
  const navTabs = userTabOrder.map(id => allTabs[id]).filter(Boolean);
  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 480,
      background: 'var(--nav-bg, rgba(45,58,68,0.96))', borderTop: '1px solid rgba(255,255,255,0.08)',
      display: 'flex', alignItems: 'stretch',
      zIndex: 100, paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    }}>
      {navTabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => { if (tab.auth && !user) navigate('/login'); else navigate(tab.path); }}
          style={{
            flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', padding: '10px 0 8px', border: 'none',
            background: 'transparent', cursor: 'pointer', position: 'relative', gap: 4,
          }}
          aria-label={tab.label}
        >
          {tab.active && (
            <div style={{
              position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)',
              width: '50%', height: 4, borderRadius: '0 0 4px 4px', background: '#60a5fa',
              boxShadow: '0 0 12px rgba(96,165,250,0.55)',
            }} />
          )}
          <tab.Icon
            color={tab.active ? '#60a5fa' : 'rgba(238,242,245,0.5)'}
            size={tab.active ? 24 : 22}
          />
          <span style={{
            fontSize: 11,
            fontWeight: tab.active ? 700 : 500,
            color: tab.active ? '#60a5fa' : 'rgba(238,242,245,0.55)',
            letterSpacing: '0.01em',
          }}>{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}
